export default "__VITE_ASSET__DqvZsmEG__"